<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler"
          :items="mcap.months"
          :fields="fields"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template slot="Functions" slot-scope="data">
             <b-link :href="data.item.MailSpotterLink"
             target="_new_tab"
             v-text="LinkVerbiage"
             v-if = "canTrack && data.item.MailSpotterLink.length"
             >
               
             </b-link>
          </template>
        </b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRows"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import cTable from "@/views/base/Table.vue";
//import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
//import MyBaseTable from "@/components/base/MyBaseTable.vue";
import StyledDialog from "@/components/dialogs/StyledModal.vue";

export default {
  name: "MyMonthList",
  data: () => {
    return {
      fields: [
        {
          key: "MailDateString",
          label: "Mail Date",
          sortable: true,
          thStyle: "width: 30%;"
        },
        {
          key: "Description",
          label: "Description",
          sortable: true
        },
        {
          key: "OrderCount",
          label: "Orders Processed",
          sortable: true
        }, 
        {
          key: "Functions",
          label: "",
          sortable: false, 
          
        }
      ],
      mySelected: {},
      currentPage: 1,
      perPage: 12, 
      LinkVerbiage: "Track Mail"
    };
  },
  props: {},
  components: {
    cTable,
    StyledDialog
    //MyBaseTable
  },
  created() {
    this.$store.dispatch("mcap/getMonths");
  },
  computed: {
    totalRows: function() {
      return this.$store.state.mcap.months.length;
      //return 4;
    },
    canTrack: function() {
      return this.$store.state.n_user.n_current_user.CanTrack;        
    },
    
    isNavVisible: function() {
      return this.totalRows > this.perPage;
    },
    ...mapState(["mcap", "notification"]),
    ...mapActions("notification", ["add", "remove"])
  },
  updated() {
    this.incrementCount;
  },
  methods: {
    myRowClickHandler(record, index) {
      this.$store
        .dispatch("mcap/getClientDirectOrders", record.CapBase)
        .then(() => {
          this.$router.push({ name: "ClientDirectOrders" });
        });
    }, 
    TrackItem(_item) {
      //console.log(_item);
    }
  }
};
</script>

<style scoped>
.my-tbl-function {
  width: 10% !important;
  color: red;
}
</style>